<template>
  <div :class="classObj" class="app-wrapper">
    <!-- 如果 mobile && sidebar is open 然后 class 背景样式，点击事件 -->
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <!-- 左侧侧边栏 -->
    <sidebar class="sidebar-container" />
    
    <!-- 右侧主区域 -->
    <div :class="{hasTagsView:needTagsView}" class="main-container">
      <!-- 顶部导航栏和tags -->
      <div :class="{'fixed-header':fixedHeader}">
        <navbar />
        <tags-view v-if="needTagsView" />
      </div>
      <!-- 主区域 -->
      <app-main />

      <!-- 右侧面板 弹出 设置 -->
      <right-panel v-if="showSettings">
        <settings />
      </right-panel>
    </div>

  </div>

</template>

<script>
/**
 * LayOut 主要包括
 * RightPanel 右侧面板
 * AppMain 主显示区域
 * Navbar 导航栏
 * TagsView 标签区域，（tab）
 * Settings 设置区域
 * Sidebar 左侧的侧边栏
 */
import RightPanel from '@/components/RightPanel'
import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'

export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    RightPanel,
    Settings,
    Sidebar,
    TagsView
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    classObj() {
		/**
		 * class 样式状态
		**/
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
	 /**
	   * 关闭左侧侧边栏
	   */
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }
	/**
	* 移动设备的抽屉背景颜色
	**/ 
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>
